<template>
  <div class="login-form-container">
    <h1 class="login-form-card-title">Reset your password</h1>
    <a-form
      ref="resetForm"
      layout="vertical"
      :form="form"
      :action="passwordUrl"
      method="POST"
      :style="{ marginBottom: '4px' }"
      @submit.stop.prevent="handleSubmit"
    >
      <input type="hidden" name="authenticity_token" :value="csrfToken" />
      <a-form-item>
        <span slot="label">Email</span>
        <a-input
          v-decorator="[
            'email',
            {
              rules: [
                {
                  type: 'email',
                  required: true,
                  message: 'Please enter a valid email address',
                },
              ],
            },
          ]"
          name="user[email]"
          autoFocus
        />
      </a-form-item>
      <a-button name="commit" type="primary" htmlType="submit">
        Reset
      </a-button>
    </a-form>
    <div>
      <a :href="sessionUrl">Log in </a>
    </div>
    <div>
      <a :href="ssoUrl">Log in with SSO</a>
    </div>
  </div>
</template>

<script>
import csrf from "@/lib/csrf.js";

export default {
  props: {
    urls: {
      type: Object,
      required: true,
      validator: (urls) => {
        return (
          typeof urls.password === "string" &&
          typeof urls.session === "string" &&
          typeof urls.users === "object"
        );
      },
    },
  },

  data() {
    return {
      form: this.$form.createForm(this, {
        name: "resetPassword",
        onValuesChange: this.handleFormChange,
      }),
    };
  },

  computed: {
    csrfToken() {
      return csrf.token;
    },
    sessionUrl() {
      return this.urls.session;
    },
    ssoUrl() {
      return this.urls.users.sso;
    },
    passwordUrl() {
      return this.urls.password;
    },
  },

  methods: {
    handleSubmit() {
      this.form.validateFields(async (err) => {
        if (!err) {
          // Instead of submitting this through axios, we are doing a regular form submission here.
          // This is because Devise will return a 302 Found, and redirect us to the login page.
          // Devise also flashes a helpful message letting you know that you can expect to receive an email
          // but axios swallows that message.
          this.$refs.resetForm.$el.submit();
        }
      });
    },
  },
};
</script>

<style scoped>
@import "../../sessions/login.css";
</style>
